import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Typography } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants/routes';
import { SurveyTemplate } from '@/surveys/state';

type Props = {
  surveyTemplateName?: string;
  metricsCount?: number;
};

export const ResultsNotVisible: FC<Props> = ({ surveyTemplateName, metricsCount }) => {
  const t = useTranslations('dashboard.learning.noResultsVisible');

  const navigate = useNavigate();

  const onNavigate = () => {
    if (surveyTemplateName === SurveyTemplate.SoftSkillAssessment) {
      navigate(Routes.TrainingSoftSkills);
      return;
    }
    navigate(Routes.TrainingHardSkills);
  };

  return (
    <Box mb='m' textAlign='center'>
      <Typography variant='h2' mb='xxs'>
        {surveyTemplateName}
      </Typography>
      <Typography mb='s' variant='p3/light'>
        {t('description', { metricsCount, surveyTemplateName })}
      </Typography>
      <Button mx='auto' variant='primary' onClick={onNavigate}>
        {t('buttonLabel')}
      </Button>
    </Box>
  );
};
